import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Announced } from "@fluentui/react";
import * as React from "react";
const LoadingAnnouncementContext = React.createContext(undefined);
export const useLoadingAnnouncement = () => {
    const context = React.useContext(LoadingAnnouncementContext);
    if (!context) {
        throw new Error("useLoadingAnnouncement must be used within LoadingAnnouncementProvider");
    }
    return context;
};
export const LoadingAnnouncementProvider = ({ children, }) => {
    const [message, setMessage] = React.useState("");
    const announce = React.useCallback((nextMessage) => {
        setMessage(nextMessage);
    }, []);
    const clear = React.useCallback(() => {
        setMessage("");
    }, []);
    const value = React.useMemo(() => ({ announce, clear }), [announce, clear]);
    return (_jsxs(LoadingAnnouncementContext.Provider, Object.assign({ value: value }, { children: [_jsx(Announced, { "aria-atomic": "true", message: message }), children] })));
};
